import { alpha, ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	selected: boolean;
	onClick: () => void;
	label: string;
	icon: ReactNode;
};

export const SelectableCardButton: FC<Props> = ({
	selected,
	onClick,
	label,
	icon,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			type="button"
			onClick={onClick}
			sx={{
				flex: 1,
				width: "100%",
				flexDirection: "column",
				gap: 0.6,
				py: 1.2,
				borderRadius: "12px",
				border: `1px solid ${
					selected
						? theme.palette.primary.main
						: theme.palette.deprecated.grey[200]
				}`,
				bgcolor: selected
					? alpha(theme.palette.primary.main, 0.08)
					: theme.palette.background.paper,
				transition: "all 120ms ease-out",
			}}
		>
			{icon}
			<Typography
				fontSize={12}
				fontWeight={500}
				color={theme.palette.deprecated.grey[700]}
			>
				{label}
			</Typography>
		</ButtonBase>
	);
};
